// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.first-page {
  background-color: red;
  height: 841.89;
  /* padding: 20mm; */
}

.brand-box {
  background: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/23618/rip.svg")
    bottom center no-repeat;
  background-size: 100%;
  width: 100%;
  height: 30%;
  margin-top: 70mm;
  color: red !important;
}

.combined-report-component {
  background-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.02) 1px,
      transparent 1px
    ),
    linear-gradient(to bottom, rgba(0, 0, 0, 0.02) 1px, transparent 1px);

  background-size: 20px 20px;
  background-position: 0 0;
}
`, "",{"version":3,"sources":["webpack://./src/views/admin/default/Report/FirstPage/FirstPage.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;2BACyB;EACzB,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE;;;;;wEAKsE;;EAEtE,0BAA0B;EAC1B,wBAAwB;AAC1B","sourcesContent":[".first-page {\n  background-color: red;\n  height: 841.89;\n  /* padding: 20mm; */\n}\n\n.brand-box {\n  background: url(\"https://s3-us-west-2.amazonaws.com/s.cdpn.io/23618/rip.svg\")\n    bottom center no-repeat;\n  background-size: 100%;\n  width: 100%;\n  height: 30%;\n  margin-top: 70mm;\n  color: red !important;\n}\n\n.combined-report-component {\n  background-image: linear-gradient(\n      to right,\n      rgba(0, 0, 0, 0.02) 1px,\n      transparent 1px\n    ),\n    linear-gradient(to bottom, rgba(0, 0, 0, 0.02) 1px, transparent 1px);\n\n  background-size: 20px 20px;\n  background-position: 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
